import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { clientApi } from '@/config/axios';
import { useAuth } from '@/lib/auth/AuthContext';
export interface CustomPatientField {
  id: string;
  label: string;
  options: string[];
}
export interface PatientConfiguration {
  revision: number;
  fields: CustomPatientField[];
  mrn: {
    mode: 'manual' | 'random' | 'rule';
    prefix: string;
    include_year: boolean;
    digits: number;
    next_number: number;
  };
}
export function usePatientConfiguration() {
  const { organization } = useAuth();
  const org = organization?.organization_id;
  return useQuery({
    queryKey: ['patient-configuration', org],
    enabled: !!org,
    queryFn: async () =>
      (await clientApi.get<PatientConfiguration>(`/api/v1/organizations/${org}/patient-configuration`)).data,
  });
}
export function useSavePatientConfiguration() {
  const { organization } = useAuth();
  const org = organization?.organization_id;
  const cache = useQueryClient();
  return useMutation({
    mutationFn: async (body: PatientConfiguration) =>
      (await clientApi.put<PatientConfiguration>(`/api/v1/organizations/${org}/patient-configuration`, body)).data,
    onSuccess: (data) => {
      cache.setQueryData(['patient-configuration', org], data);
    },
  });
}
